"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetRecoil = exports.setRecoil = exports.getRecoilPromise = exports.getRecoil = void 0;
var recoil_1 = require("recoil");
var nexus = {};
function RecoilNexus() {
  nexus.get = (0, recoil_1.useRecoilCallback)(function (_a) {
    var snapshot = _a.snapshot;
    return function (atom) {
      return snapshot.getLoadable(atom).contents;
    };
  }, []);
  nexus.getPromise = (0, recoil_1.useRecoilCallback)(function (_a) {
    var snapshot = _a.snapshot;
    return function (atom) {
      return snapshot.getPromise(atom);
    };
  }, []);
  nexus.set = (0, recoil_1.useRecoilCallback)(function (_a) {
    var transact_UNSTABLE = _a.transact_UNSTABLE;
    return function (atom, valOrUpdater) {
      transact_UNSTABLE(function (_a) {
        var set = _a.set;
        set(atom, valOrUpdater);
      });
    };
  }, []);
  nexus.reset = (0, recoil_1.useRecoilCallback)(function (_a) {
    var reset = _a.reset;
    return reset;
  }, []);
  return null;
}
exports.default = RecoilNexus;
function getRecoil(atom) {
  return nexus.get(atom);
}
exports.getRecoil = getRecoil;
function getRecoilPromise(atom) {
  return nexus.getPromise(atom);
}
exports.getRecoilPromise = getRecoilPromise;
function setRecoil(atom, valOrUpdater) {
  nexus.set(atom, valOrUpdater);
}
exports.setRecoil = setRecoil;
function resetRecoil(atom) {
  nexus.reset(atom);
}
exports.resetRecoil = resetRecoil;